//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion


import { ColumnModel } from "../api/api.models"

import { CreateEditInitParams, BulkEditInitParams } from "../common/create-edit-popup/create-edit-popup.controller"

import { DataProvider, CommonHelper, LocalizationHelper, ToastHelper } from "../../helpers"

import { Enums } from "../../models/common"
import { OpOperatorGroup } from "../../models/core"
import { SESSION } from "../../models/custom"

export class OperatorGroupHelper {

    // #region Consts

    public static get FILE_NAME_PREFIX(): string { return 'operator-group' }
    public static get REFERENCE_TYPE(): Enums.ReferenceType { return Enums.ReferenceType.IdOperatorGroup }
    public static get SIMAX_MODULE_NAME(): Enums.SimaxModuleName { return Enums.SimaxModuleName.Operator_Group }
    public static get LOG_PREFIX(): string { return '[SIMAX.Models.OperatorGroup]' }

    // #endregion


    // #region Methods

    public static deleteOperatorGroup(dataProvider: DataProvider, operatorGroup: OpOperatorGroup, moduleName: Enums.SimaxModuleName): any {
        const deferred: JQueryDeferred<void> = $.Deferred<void>()

        dataProvider
            .OperatorGroup
            .deleteOperatorGroup(operatorGroup)
            .then(() => {
                ToastHelper.showSuccess(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETED, moduleName))
                deferred.resolve()
            })
            .fail((error: any) => {
                let errorMsg: string = error

                if (SESSION.isType(error)) {
                    errorMsg = (<SESSION>error).toString()
                    ToastHelper.showError(errorMsg)
                } else {
                    ToastHelper.showError(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETE_ERROR, moduleName))
                }

                deferred.reject(errorMsg)
            })

        return deferred
    }

    public static saveOperatorGroup(dataProvider: DataProvider, operatorGroup: OpOperatorGroup, moduleName: Enums.SimaxModuleName, isBulkSave: boolean = false): JQueryPromise<OpOperatorGroup> {
        const deferred: JQueryDeferred<OpOperatorGroup> = $.Deferred<OpOperatorGroup>()

        dataProvider.OperatorGroup
            .saveOperatorGroup(operatorGroup)
            .then((savedObject: OpOperatorGroup) => {
                if (!isBulkSave) {
                    ToastHelper.showSuccess(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, moduleName))
                    CommonHelper.setValueToLocalStorage(CommonHelper.localStorageVarForSavedEntity.operatorGroupSaved, true, 0)
                }

                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                let errorMsg: string = error

                if (SESSION.isType(error)) {
                    errorMsg = (<SESSION>error).toString()
                }

                if (!isBulkSave) {
                    ToastHelper.showError(errorMsg)
                }

                deferred.reject(errorMsg)
            })

        return deferred.promise()
    }

    public static getOperatorColumn(): ColumnModel[] {
        const column: ColumnModel = new ColumnModel()

        column.id = 1
        column.idName = "name"
        column.name = 'Name'
        column.type = Enums.DataTypeClass.Text
        column.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Operator)

        return [column]
    }

    
    //#region Options

    public static getBulkEditInitParams(columns: any, selectedRows: any[]): BulkEditInitParams {
        return {
            gridColumns: columns,
            groupReferenceType: null,
            groupReferenceValue: null,
            idReferenceType: OperatorGroupHelper.REFERENCE_TYPE,
            moduleName: OperatorGroupHelper.SIMAX_MODULE_NAME,
            section: null,
            selectedGridRows: selectedRows,
            useBusinessObjects: true
        }
    }

    public static getEditInitParams(operatorGroupId: number = 0, referenceObject: OpOperatorGroup = null): CreateEditInitParams {
        return {
            createEditSelectedTabType: Enums.SimaxCreateEditSelectedTabType.BaseParameters,
            groupReferenceType: null,
            groupReferenceValue: null,
            idReferenceType: OperatorGroupHelper.REFERENCE_TYPE,
            moduleName: OperatorGroupHelper.SIMAX_MODULE_NAME,
            referenceObject: referenceObject,
            referenceObjectId: operatorGroupId,
            sections: null,
            useBusinessObjects: true
        }
    }

    // #endregion
}